module.exports = __webpack_public_path__ + "static/konfio-5cf1e81dd2a394b12a6cc8432af0595d.png";